<template>
    <div class="mobile-banner">
        <Swiper
            class="mobile-banner__swiper"
            :modules="bannerModules"
            :autoplay="true"
            :pagination="true"
            :slides-per-view="1"
            :space-between="0"
        >
            <SwiperSlide v-for="banner in bannerList" :key="banner.id">
                <img class="swiper-image" :src="banner.httpUrl" />
            </SwiperSlide>
        </Swiper>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, Pagination } from 'swiper/modules'
import * as api from '@/api/index'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/pagination'

export default {
    name: 'MobileBanner',
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            bannerList: [],
            bannerModules: [Autoplay, Pagination],
        }
    },
    methods: {
        async getBannerList() {
            const { data } = await api.getActivityList()
            this.bannerList = data.data
        },
    },
    created() {
        this.getBannerList()
    },
}
</script>

<style lang="less">
.mobile-banner {
    height: 4rem;

    &__swiper {
        height: 100%;

        .swiper-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .swiper-pagination {
            bottom: 0.2rem;

            .swiper-pagination-bullet {
                width: 0.18rem;
                height: 0.18rem;
                background-color: var(--color-primary);
                margin: 0 0.06rem;
                transition: background-color 0.3s ease;
                opacity: unset;

                &.swiper-pagination-bullet-active {
                    background-color: #fff;
                    border: 1px solid var(--color-primary);
                }
            }
        }
    }
}
</style>
